import { Component, inject, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageComponent } from '../../../infrastructure/shared/components/page/page';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../../infrastructure/shared/ui/button/button';
import { FieldComponent } from '../../../infrastructure/shared/ui/field/field';
import { EmailInputComponent } from '../../../infrastructure/shared/components/email-input/email-input';
import { TextInput } from '../../../infrastructure/shared/ui/text-input/text-input';
import { ChevronRight } from '../../../infrastructure/shared/icons/chevron-right/chevron-right';
import { Lock03 } from '../../../infrastructure/shared/icons/lock-03/lock-03';
import { ChangePasswordDialog } from './change-password-dialog/change-password-dialog';
import { UserService } from '../../../infrastructure/shared/services/user.service';
import { AuthService } from '../../../infrastructure/shared/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-admin-profile',
  imports: [
    PageComponent,
    ButtonComponent,
    FieldComponent,
    EmailInputComponent,
    TextInput,
    Lock03,
    ChevronRight,
    ChangePasswordDialog,
  ],
  templateUrl: './admin-profile.html',
  styleUrl: './admin-profile.scss',
})
export class AdminProfile {
  private readonly _user = inject(UserService);
  private readonly _auth = inject(AuthService);

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  protected emailCtrl = new FormControl<string>(
    { value: this._user.getUserData.email ?? '', disabled: true },
    { nonNullable: true },
  );
  protected passwordCtrl = new FormControl<string>(
    { value: '************', disabled: true },
    { nonNullable: true },
  );

  protected changePasswordDialogVisible = signal<boolean>(false);

  protected openChangePassword(): void {
    this.changePasswordDialogVisible.set(true);
  }

  protected logout(): void {
    this._auth.logout();
  }
}
